// extracted by mini-css-extract-plugin
export default {"root":"week-module___root___da7fa6f6"};